import { render, staticRenderFns } from "./MultiPlanCategoryRoi.vue?vue&type=template&id=7648375c&scoped=true"
import script from "./MultiPlanCategoryRoi.vue?vue&type=script&lang=js"
export * from "./MultiPlanCategoryRoi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7648375c",
  null
  
)

export default component.exports